<template>
  <div class="vuec-PainelCliente">
    <v-container fluid class="pa-0">
      <v-row v-if="currentReportSPs && showTable">
        <v-col cols="12">
          <DynamicDataTable :storedProcedures="currentReportSPs" />
        </v-col>
      </v-row>
      <v-row v-if="iframeOk">
        <v-col cols="12">
          <!-- Renderiza o iframe apenas se o JSON for válido -->
          <iframe
            v-if="FrameReport"
            :src="FrameReport"
            :width="w_frame"
            :height="h_frame"
            frameborder="0"
          ></iframe>
        </v-col>
      </v-row>
        
        <v-row>
          <v-btn
            class="my-2"
            color="red"
            @click="closeCreate"
          >
              {{ $t('Guid.close') }}
          </v-btn>
        </v-row>
      
    </v-container>
  </div>
</template>


<script>
import DynamicDataTable from "@/components/DynamicDataTable.vue";
import { mapGetters,mapActions  } from 'vuex';
  export default {
    components: { DynamicDataTable },
    props: {
    },
    data() {
      return {
        FrameReport:null,
        frame:null,
        w_frame:800,
        h_frame:600,
        iframeOk:false,
        showTable: true 
      }
    },
    async mounted() {
      this.frame = this.getCurrentReport
      await this.changeFrame()
      
    },
    created() {
      let anchoPantalla = window.innerWidth;
      let altoPantalla = window.innerHeight;
      this.w_frame = anchoPantalla * 0.8;
      this.h_frame = altoPantalla * 0.8;

    },
    computed:{
      ...mapGetters(['getCurrentReport','getTokenMetabaseCurrentReport', 'getIndexReport']),
      ...mapGetters(['getListReports']),
      currentReportSPs() {
        try{
          const report = this.getListReports[this.getIndexReport].report_Data;
          if (report.includes('METABASE_SECRET_KEY')) {
            return '';
          }
         
          return report;
        }catch (error){
          console.error("Erro ao analisar o JSON em currentReportSPs:", error);
          return null;
        }
      },
      reportData() {
        return this.getCurrentReport;
      }
    },
    methods: {
      ...mapActions(['GetTokenMetabase']),
      closeCreate() {
        this.$router.push({ name: 'reports' });
      },
      async changeFrame(){
        this.iframeOk = false;
          try {
            this.client = localStorage.getItem("customer_Id")
            const currentReport = this.getListReports[this.getIndexReport].report_Data;
            if(currentReport.includes('METABASE_SECRET_KEY')){
              let jsonIframe = JSON.parse(this.getCurrentReport)
              
              
              let data = {
                customer_id:this.client,
                visualization_id:jsonIframe.visualization_id,
                visualization_type:jsonIframe.visualization_type,
                key:jsonIframe.METABASE_SECRET_KEY
              }

              await this.GetTokenMetabase(data);

              jsonIframe.iframeUrl = jsonIframe.iframeUrl.replace('@token',this.getTokenMetabaseCurrentReport)
              this.FrameReport = jsonIframe.iframeUrl;
              this.iframeOk = true;
              this.showTable = false;
            } 
            else {
              this.FrameReport = null;
              this.iframeOk = false;
              this.showTable = true;
            }  
                  
          } catch (error) {
              console.error("Erro ao carregar o iframe teste:", error);
          }
        }
  },
  watch:{
    reportData: {
      immediate: true,
      async handler(newReport, oldReport) {
        if (newReport !== oldReport) {
          await this.changeFrame();
        }
      }
    }
  }
};

</script>